import sidebar from '@/config/sidebars/geobooster'
import createVueApp from '@/common/createApp'

Styxie.Initializers.MobileEmployees = {
  index: async(props) => {
    const { default: EmployeesIndex } = await import('@/vue_widgets/geobooster/employees/index.vue')
    createVueApp(EmployeesIndex, { props, sidebar })
  },
  new: async(props) => {
    const { default: EmployeeForm } = await import('@/vue_widgets/geobooster/employees/form/index.vue')
    createVueApp(EmployeeForm, { props, sidebar })
  },
  edit: async(props) => {
    const { default: EmployeeForm } = await import('@/vue_widgets/geobooster/employees/form/index.vue')
    createVueApp(EmployeeForm, { props, sidebar })
  }
}
